import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import ErrorBoundary from './components/common/ErrorBoundary';
import { AuthProvider } from './hooks/useAuth';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </Router>
);
